import { Link } from "react-router-dom";
import { Sparkle, ArrowRight, Clock } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

// Banner shown only when the demo account is signed in. Encourages signup
// and makes the sandbox status crystal clear.
export default function DemoModeRibbon() {
  const { user, logout } = useAuth();
  // Heuristic: any user whose email starts with "demo" or whose name is "Demo …"
  // counts as a demo session. The backend gates the demo-login endpoint to a
  // single account, so this is safe to match loosely.
  const email = (user?.email || "").toLowerCase();
  const isDemo = email.startsWith("demo@") || email === "demo@nestledapp.io" || (user?.name || "").toLowerCase().startsWith("demo");
  if (!user || !isDemo) return null;

  return (
    <div
      data-testid="demo-mode-ribbon"
      className="relative overflow-hidden rounded-3xl border border-sage-400/40 bg-gradient-to-r from-sage-400/15 via-sage-400/10 to-terracotta-50 p-4 sm:p-5 flex flex-wrap items-center gap-4"
    >
      <div className="absolute -top-8 -right-8 h-32 w-32 rounded-full bg-sage-400/20 blur-2xl pointer-events-none" aria-hidden />
      <div className="relative flex items-center gap-3">
        <span className="relative flex h-3 w-3 shrink-0">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-sage-500 opacity-60" />
          <span className="relative inline-flex h-3 w-3 rounded-full bg-sage-500" />
        </span>
        <div>
          <div className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.22em] text-sage-600">
            <Sparkle weight="fill" size={12} /> Demo mode
          </div>
          <p className="text-sm sm:text-base text-stoneink-900 font-medium mt-0.5">
            You&apos;re exploring our shared demo home.
            <span className="text-stoneink-500 font-normal hidden sm:inline">
              {" "}Add anything you like — it&apos;ll reset overnight.
            </span>
          </p>
        </div>
      </div>

      <div className="relative ml-auto flex flex-wrap items-center gap-2">
        <div className="hidden md:flex items-center gap-1.5 text-xs text-stoneink-500 px-3 py-1.5 rounded-full bg-white/70 border border-sand-300">
          <Clock weight="duotone" size={14} /> Resets nightly · 03:00 UTC
        </div>
        <button
          onClick={logout}
          data-testid="demo-ribbon-exit"
          className="h-9 px-3 rounded-xl text-stoneink-700 hover:bg-white/70 text-sm font-medium"
        >
          Exit demo
        </button>
        <Link
          to="/register"
          data-testid="demo-ribbon-signup"
          className="h-9 px-4 rounded-xl bg-terracotta-500 hover:bg-terracotta-600 text-white text-sm font-semibold flex items-center gap-1.5 active:scale-[0.98] transition-all"
        >
          Make this yours <ArrowRight weight="bold" size={14} />
        </Link>
      </div>
    </div>
  );
}
